module.exports = __webpack_public_path__ + "img/swap_vert.96dd9870.svg";